<template>
  <div class="msg" v-cloak>
    <!-- 关闭按钮 -->
    <div class="close" @click="closeWindow">
      <img src="../assets/img/close.png" alt="" />
    </div>
    <!-- 正文 -->
    <div class="content">
      <div class="title">企业信息提报</div>
      <!-- 1、基本信息 -->
      <div class="basic">
        <div class="title1">1.基本信息</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          :inline="true"
          label-position="left"
          size="medium"
        >
          <el-form-item
            v-cloak
            label="公司名称"
            label-width="120px"
            prop="company_name"
            style="width: 550px"
          >
            <el-input
              v-model="jsonData.company_name"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.company_code"
            label="统一信用代码"
            prop="company_code"
            label-width="120px"
          >
            <el-input
              v-model="jsonData.company_code"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.registration_time"
            label="注册时间"
            style="width: 550px"
            label-width="120px"
          >
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="jsonData.registration_time"
              style="width: 400px"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.area"
            label="注册地区"
            prop="area"
            label-width="120px"
          >
            <span
              style="
                padding: 7px 10px;
                background-color: #e9ecef;
                border-radius: 5px;
                border: 1px #ced4da solid;
              "
              >河南</span
            >
            <el-cascader
              v-model="jsonData.area"
              :options="options"
              style="width: 350px"
              :props="{ expandTrigger: 'hover', checkStrictly: 'true' }"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.economy_industry"
            label="工商注册行业"
            label-width="120px"
            style="width: 550px"
          >
            <el-cascader
              v-model="jsonData.economy_industry"
              :options="options1"
              style="width: 400px"
              :props="{ expandTrigger: 'hover', checkStrictly: 'true' }"
            >
            </el-cascader>
            <div class="explain_item">说明：参考国民经济行业</div>
          </el-form-item>

          <el-form-item
            v-cloak
            label="政策行业"
            label-width="120px"
            v-if="ruleForm.policy_industry"
          >
            <el-select
              v-model="jsonData.policy_industry"
              placeholder="请选择"
              style="width: 400px"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="explain_item">
              说明：惠企政策中重点支持的产业，与工商注册行业不冲突
            </div>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.company_type"
            label="单位类型"
            label-width="120px"
            style="width: 550px; height: 40px"
          >
            <el-select
              v-model="jsonData.company_type"
              placeholder="请选择"
              style="width: 400px"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="explain_item" style="margin: 5px 0 20px 0">
              说明：部分政策涉及区分单位类型
            </div>
          </el-form-item>

          <el-form-item
            v-cloak
            label="企业资质"
            label-width="120px"
            v-if="ruleForm.qualification"
          >
            <el-select
              v-model="jsonData.qualification"
              multiple
              collapse-tags
              style="width: 400px"
              placeholder="请选择已获得资质荣誉"
            >
              <el-option
                v-for="item in options4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="explain_item" style="margin: 5px 0 5px 0">
              说明：已获得资质荣誉(多选)
            </div>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.listed_company"
            label="是否上市"
            label-width="120px"
            style="height: 70px; width: 550px"
          >
            <el-select
              v-model="jsonData.listed_company"
              placeholder="请选择"
              style="width: 400px"
            >
              <el-option
                v-for="item in options5"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="explain_item" style="margin: 5px 0 30px 0">
              说明：涉及上市相关政策
            </div>
          </el-form-item>

          <div class="line">
            <el-form-item
              v-cloak
              v-if="ruleForm.is_cooperation"
              label="是否和院校/科研院所有合作"
              label-width="120px"
            >
              <el-select
                v-model="jsonData.is_cooperation"
                placeholder="请选择"
                style="width: 400px"
              >
                <el-option
                  v-for="item in options5"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="line" style="margin-left: 25px">
            <el-form-item
              v-cloak
              v-if="ruleForm.is_violation"
              label="是否有重大违规问题"
              label-width="120px"
              style="margin: 0"
            >
              <el-select
                v-model="jsonData.is_violation"
                placeholder="请选择"
                style="width: 400px"
              >
                <el-option
                  v-for="item in options5"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div
                class="explain_item"
                style="line-height: 21px; margin: 20px 0 40px 0"
              >
                说明：近三年内未发生重大安全、重大质量事故和严重环境违法、科研
                <div>
                  严重失信行为，且企业未列入经营异常名录和严重违法失信企业名单
                </div>
              </div>
            </el-form-item>
          </div>

          <!-- 2、人力情况 -->
          <div class="title1">
            2.人力情况<span class="explain" style="font-weight: 500"
              >指标说明：涉及人才类、人社口和其他大部分相关政策</span
            >
          </div>

          <el-form-item
            v-cloak
            label="职工总数(人)"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.employees_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-cloak
            v-if="ruleForm.researcher_num"
            label="研发人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.researcher_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.college_num"
            label="大专人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.college_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-cloak
            v-if="ruleForm.undergraduate_num"
            label="本科人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.undergraduate_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.master_num"
            label="硕士人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.master_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-cloak
            v-if="ruleForm.doctor_num"
            label="博士人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.doctor_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-cloak
            v-if="ruleForm.academician_num"
            label="院士人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.academician_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-cloak
            v-if="ruleForm.intermediate_num"
            label="中级职称人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.intermediate_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-cloak
            v-if="ruleForm.senior_num"
            label="高级职称人数"
            label-width="110px"
            style="margin-right: 60px"
          >
            <el-input
              type="number"
              v-model="jsonData.senior_num"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>

          <!-- 3、经营情况 -->
          <div class="title1" style="margin-top: 20px">
            <span style="min-width: 120px;">
              3.经营情况
            </span>
            <span
              class="explain"
              style="font-weight: 500; margin-right: 520px"
              >指标说明：用于区分企业规模，涉及减税政策和其他大部分相关政策</span
            >
            <span style="font-size: 17px;text-align: right;width: 40%;">单位：万元</span>
          </div>

          <table>
            <tr>
              <td
                class="tab-title"
                style="width: 130px; background-color: #e9ecef"
              >
                年份
              </td>
              <td
                class="tab-title"
                style="background-color: #e9ecef"
              >
                资产总额
              </td>
              <td
                class="tab-title"
                style="background-color: #e9ecef"
              >
                营业收入
              </td>
              <td
                class="tab-title"
                style="background-color: #e9ecef"
              >
                净利润
              </td>
              <td
                class="tab-title"
                style="background-color: #e9ecef"
              >
                研发费用
              </td>
            </tr>
            <tr
              v-cloak
            >
              <td>{{ last1 }}</td>
              <td>
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.assets1"
                  style="width: 200px"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.income1"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.profit1"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.research1"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
            </tr>
            <tr
              v-cloak
              v-if="
                ruleForm.assets2 ||
                ruleForm.income2 ||
                ruleForm.profit2 ||
                ruleForm.research2
              "
            >
              <td>{{ last2 }}</td>
              <td v-if="ruleForm.assets2">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.assets2"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.income2">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.income2"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.profit2">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.profit2"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.research2">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.research2"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
            </tr>
            <tr
              v-cloak
              v-if="
                ruleForm.assets3 ||
                ruleForm.income3 ||
                ruleForm.profit3 ||
                ruleForm.research3
              "
            >
              <td>{{ last3 }}</td>
              <td v-if="ruleForm.assets3">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.assets3"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.income3">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.income3"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.profit3">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.profit3"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
              <td v-if="ruleForm.research3">
                <el-input
                  v-cloak
                  type="number"
                  v-model="jsonData.research3"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 200px"
                ></el-input>
              </td>
            </tr>
          </table>

          <!-- 4、知识产权 -->
          <div class="title1" style="margin-top: 50px">
            4.知识产权<span class="explain" style="font-weight: 500"
              >指标说明：涉及品牌、知识产权类和其它大部分相关政策</span
            >
          </div>

          <el-form-item
            v-cloak
            label="发明专利数量"
            label-width="110px"
          >
            <el-input
              type="number"
              v-model="jsonData.invention_patent"
              style="width: 400px"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <div class="line" v-if="ruleForm.utility_model_patent" v-cloak>
            <el-form-item label="实用新型专利数量" label-width="110px">
              <el-input
                type="number"
                v-model="jsonData.utility_model_patent"
                style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item
              v-cloak
              v-if="ruleForm.industrial_design_patent"
              label="外观设计专利数量"
              label-width="110px"
            >
              <el-input
                type="number"
                v-model="jsonData.industrial_design_patent"
                style="width: 400px"
                oninput="value=value.replace(/[^0-9.]/g,'')"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              v-cloak
              v-if="ruleForm.software_copyright"
              label="软件著作权数量"
              label-width="110px"
            >
              <el-input
                type="number"
                v-model="jsonData.software_copyright"
                style="width: 400px"
                oninput="value=value.replace(/[^0-9.]/g,'')"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              v-cloak
              v-if="ruleForm.other_copyright"
              label="其它著作权数量"
              label-width="110px"
            >
              <el-input
                type="number"
                v-model="jsonData.other_copyright"
                style="width: 400px"
                oninput="value=value.replace(/[^0-9.]/g,'')"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <!-- 确认提交 -->
        <!-- 按钮 -->
        <el-button
          type="primary"
          style="
            height: 65px;
            font-size: 21px;
            background-color: #2967de;
            margin-top: 7%;
            margin-left: 42%;
            padding: 15px 60px;
            letter-spacing: 3px;
            border-radius: 10px;
          "
          @click="postForm()"
          >确认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["policy_id", "companyName"],
  data() {
    return {
      userid: "",
      last1: "",
      last2: "",
      last3: "",
      jsonData: {},
      ruleForm: {
        company_name: false,
        company_code: false,
        registration_time: false,
        area: false,
        economy_industry: false,
        policy_industry: false,
        company_type: false,
        qualification: false,
        listed_company: false,
        is_cooperation: false,
        is_violation: false,
        employees_num: false,
        researcher_num: false,
        college_num: false,
        undergraduate_num: false,
        master_num: false,
        doctor_num: false,
        academician_num: false,
        intermediate_num: false,
        senior_num: false,
        assets1: false,
        income1: false,
        profit1: false,
        research1: false,
        assets2: false,
        income2: false,
        profit2: false,
        research2: false,
        assets3: false,
        income3: false,
        profit3: false,
        research3: false,
        invention_patent: false,
        utility_model_patent: false,
        industrial_design_patent: false,
        software_copyright: false,
        other_copyright: false,
      },
      options: [
        {
          value: "郑州市",
          label: "郑州市",
          children: [
            {
              value: "中原区",
              label: "中原区",
            },
            {
              value: "二七区",
              label: "二七区",
            },
            {
              value: "管城回族区",
              label: "管城回族区",
            },
            {
              value: "金水区",
              label: "金水区",
            },
            {
              value: "上街区",
              label: "上街区",
            },
            {
              value: "惠济区",
              label: "惠济区",
            },
            {
              value: "中牟县",
              label: "中牟县",
            },
            {
              value: "巩义市",
              label: "巩义市",
            },
            {
              value: "荥阳市",
              label: "荥阳市",
            },
            {
              value: "新密市",
              label: "新密市",
            },
            {
              value: "新郑市",
              label: "新郑市",
            },
            {
              value: "登封市",
              label: "登封市",
            },
            {
              value: "航空港区",
              label: "航空港区",
            },
            {
              value: "郑东新区",
              label: "郑东新区",
            },
            {
              value: "经开区",
              label: "经开区",
            },
            {
              value: "高新区",
              label: "高新区",
            },
          ],
        },
        {
          value: "开封市",
          label: "开封市",
          children: [
            {
              value: "龙亭区",
              label: "龙亭区",
            },
            {
              value: "顺河回族区",
              label: "顺河回族区",
            },
            {
              value: "鼓楼区",
              label: "鼓楼区",
            },
            {
              value: "禹王台区",
              label: "禹王台区",
            },
            {
              value: "祥符区",
              label: "祥符区",
            },
            {
              value: "杞县",
              label: "杞县",
            },
            {
              value: "通许县",
              label: "通许县",
            },
            {
              value: "尉氏县",
              label: "尉氏县",
            },
            {
              value: "兰考县",
              label: "兰考县",
            },
          ],
        },
        {
          value: "洛阳市",
          label: "洛阳市",
          children: [
            {
              value: "老城区",
              label: "老城区",
            },
            {
              value: "西工区",
              label: "西工区",
            },
            {
              value: "瀍河回族区",
              label: "瀍河回族区",
            },
            {
              value: "涧西区",
              label: "涧西区",
            },
            {
              value: "吉利区",
              label: "吉利区",
            },
            {
              value: "洛龙区",
              label: "洛龙区",
            },
            {
              value: "孟津县",
              label: "孟津县",
            },
            {
              value: "新安县",
              label: "新安县",
            },
            {
              value: "栾川县",
              label: "栾川县",
            },
            {
              value: "嵩县",
              label: "嵩县",
            },
            {
              value: "汝阳县",
              label: "汝阳县",
            },
            {
              value: "宜阳县",
              label: "宜阳县",
            },
            {
              value: "洛宁县",
              label: "洛宁县",
            },
            {
              value: "伊川县",
              label: "伊川县",
            },
            {
              value: "偃师市",
              label: "偃师市",
            },
          ],
        },
        {
          value: "平顶山市",
          label: "平顶山市",
          children: [
            {
              value: "新华区",
              label: "新华区",
            },
            {
              value: "卫东区",
              label: "卫东区",
            },
            {
              value: "石龙区",
              label: "石龙区",
            },
            {
              value: "湛河区",
              label: "湛河区",
            },
            {
              value: "宝丰县",
              label: "宝丰县",
            },
            {
              value: "叶县",
              label: "叶县",
            },
            {
              value: "鲁山县",
              label: "鲁山县",
            },
            {
              value: "郏县",
              label: "郏县",
            },
            {
              value: "舞钢市",
              label: "舞钢市",
            },
            {
              value: "汝州市",
              label: "汝州市",
            },
          ],
        },
        {
          value: "安阳市",
          label: "安阳市",
          children: [
            {
              value: "文峰区",
              label: "文峰区",
            },
            {
              value: "北关区",
              label: "北关区",
            },
            {
              value: "殷都区",
              label: "殷都区",
            },
            {
              value: "龙安区",
              label: "龙安区",
            },
            {
              value: "安阳县",
              label: "安阳县",
            },
            {
              value: "汤阴县",
              label: "汤阴县",
            },
            {
              value: "滑县",
              label: "滑县",
            },
            {
              value: "内黄县",
              label: "内黄县",
            },
            {
              value: "林州市",
              label: "林州市",
            },
          ],
        },
        {
          value: "鹤壁市",
          label: "鹤壁市",
          children: [
            {
              value: "鹤山区",
              label: "鹤山区",
            },
            {
              value: "山城区",
              label: "山城区",
            },
            {
              value: "淇滨区",
              label: "淇滨区",
            },
            {
              value: "浚县",
              label: "浚县",
            },
            {
              value: "淇县",
              label: "淇县",
            },
          ],
        },
        {
          value: "新乡市",
          label: "新乡市",
          children: [
            {
              value: "红旗区",
              label: "红旗区",
            },
            {
              value: "卫滨区",
              label: "卫滨区",
            },
            {
              value: "凤泉区",
              label: "凤泉区",
            },
            {
              value: "牧野区",
              label: "牧野区",
            },
            {
              value: "新乡县",
              label: "新乡县",
            },
            {
              value: "获嘉县",
              label: "获嘉县",
            },
            {
              value: "原阳县",
              label: "原阳县",
            },
            {
              value: "延津县",
              label: "延津县",
            },
            {
              value: "封丘县",
              label: "封丘县",
            },
            {
              value: "卫辉市",
              label: "卫辉市",
            },
            {
              value: "辉县市",
              label: "辉县市",
            },
            {
              value: "长垣市",
              label: "长垣市",
            },
          ],
        },
        {
          value: "焦作市",
          label: "焦作市",
          children: [
            {
              value: "解放区",
              label: "解放区",
            },
            {
              value: "山阳区",
              label: "山阳区",
            },
            {
              value: "中站区",
              label: "中站区",
            },
            {
              value: "马村区",
              label: "马村区",
            },
            {
              value: "博爱县",
              label: "博爱县",
            },
            {
              value: "孟州市",
              label: "孟州市",
            },
            {
              value: "武陟县",
              label: "武陟县",
            },
            {
              value: "温县",
              label: "温县",
            },
            {
              value: "沁阳市",
              label: "沁阳市",
            },
            {
              value: "修武县",
              label: "修武县",
            },
          ],
        },
        {
          value: "濮阳市",
          label: "濮阳市",
          children: [
            {
              value: "华龙区",
              label: "华龙区",
            },
            {
              value: "清丰县",
              label: "清丰县",
            },
            {
              value: "南乐县",
              label: "南乐县",
            },
            {
              value: "范县",
              label: "范县",
            },
            {
              value: "台前县",
              label: "台前县",
            },
            {
              value: "濮阳县",
              label: "濮阳县",
            },
          ],
        },
        {
          value: "许昌市",
          label: "许昌市",
          children: [
            {
              value: "魏都区",
              label: "魏都区",
            },
            {
              value: "建安区",
              label: "建安区",
            },
            {
              value: "鄢陵县",
              label: "鄢陵县",
            },
            {
              value: "襄城县",
              label: "襄城县",
            },
            {
              value: "禹州市",
              label: "禹州市",
            },
            {
              value: "长葛市",
              label: "长葛市",
            },
          ],
        },
        {
          value: "漯河市",
          label: "漯河市",
          children: [
            {
              value: "源汇区",
              label: "源汇区",
            },
            {
              value: "郾城区",
              label: "郾城区",
            },
            {
              value: "召陵区",
              label: "召陵区",
            },
            {
              value: "舞阳县",
              label: "舞阳县",
            },
            {
              value: "临颍县",
              label: "临颍县",
            },
          ],
        },
        {
          value: "三门峡市",
          label: "三门峡市",
          children: [
            {
              value: "湖滨区",
              label: "湖滨区",
            },
            {
              value: "陕州区",
              label: "陕州区",
            },
            {
              value: "渑池县",
              label: "渑池县",
            },
            {
              value: "卢氏县",
              label: "卢氏县",
            },
            {
              value: "义马市",
              label: "义马市",
            },
            {
              value: "灵宝市",
              label: "灵宝市",
            },
          ],
        },
        {
          value: "南阳市",
          label: "南阳市",
          children: [
            {
              value: "宛城区",
              label: "宛城区",
            },
            {
              value: "卧龙区",
              label: "卧龙区",
            },
            {
              value: "南召县",
              label: "南召县",
            },
            {
              value: "方城县",
              label: "方城县",
            },
            {
              value: "西峡县",
              label: "西峡县",
            },
            {
              value: "镇平县",
              label: "镇平县",
            },
            {
              value: "内乡县",
              label: "内乡县",
            },
            {
              value: "淅川县",
              label: "淅川县",
            },
            {
              value: "社旗县",
              label: "社旗县",
            },
            {
              value: "唐河县",
              label: "唐河县",
            },
            {
              value: "新野县",
              label: "新野县",
            },
            {
              value: "桐柏县",
              label: "桐柏县",
            },
            {
              value: "邓州市",
              label: "邓州市",
            },
          ],
        },
        {
          value: "商丘市",
          label: "商丘市",
          children: [
            {
              value: "梁园区",
              label: "梁园区",
            },
            {
              value: "睢阳区",
              label: "睢阳区",
            },
            {
              value: "睢县",
              label: "睢县",
            },
            {
              value: "民权县",
              label: "民权县",
            },
            {
              value: "宁陵县",
              label: "宁陵县",
            },
            {
              value: "拓城县",
              label: "拓城县",
            },
            {
              value: "虞城县",
              label: "虞城县",
            },
            {
              value: "夏邑县",
              label: "夏邑县",
            },
            {
              value: "永城市",
              label: "永城市",
            },
          ],
        },
        {
          value: "信阳市",
          label: "信阳市",
          children: [
            {
              value: "浉河区",
              label: "浉河区",
            },
            {
              value: "平桥区",
              label: "平桥区",
            },
            {
              value: "罗山县",
              label: "罗山县",
            },
            {
              value: "光山县",
              label: "光山县",
            },
            {
              value: "新县",
              label: "新县",
            },
            {
              value: "商城县",
              label: "商城县",
            },
            {
              value: "固始县",
              label: "固始县",
            },
            {
              value: "潢川县",
              label: "潢川县",
            },
            {
              value: "淮滨县",
              label: "淮滨县",
            },
            {
              value: "息县",
              label: "息县",
            },
          ],
        },
        {
          value: "周口市",
          label: "周口市",
          children: [
            {
              value: "川汇区",
              label: "川汇区",
            },
            {
              value: "淮阳区",
              label: "淮阳区",
            },
            {
              value: "扶沟县",
              label: "扶沟县",
            },
            {
              value: "西华县",
              label: "西华县",
            },
            {
              value: "商水县",
              label: "商水县",
            },
            {
              value: "沈丘县",
              label: "沈丘县",
            },
            {
              value: "郸城县",
              label: "郸城县",
            },
            {
              value: "太康县",
              label: "太康县",
            },
            {
              value: "鹿邑县",
              label: "鹿邑县",
            },
            {
              value: "项城市",
              label: "项城市",
            },
          ],
        },
        {
          value: "驻马店市",
          label: "驻马店市",
          children: [
            {
              value: "驿城区",
              label: "驿城区",
            },
            {
              value: "西平县",
              label: "西平县",
            },
            {
              value: "上蔡县",
              label: "上蔡县",
            },
            {
              value: "平舆县",
              label: "平舆县",
            },
            {
              value: "正阳县",
              label: "正阳县",
            },
            {
              value: "确山县",
              label: "确山县",
            },
            {
              value: "沁阳县",
              label: "沁阳县",
            },
            {
              value: "汝南县",
              label: "汝南县",
            },
            {
              value: "遂平县",
              label: "遂平县",
            },
            {
              value: "新蔡县",
              label: "新蔡县",
            },
          ],
        },
        {
          value: "直辖县级行政区划",
          label: "直辖县级行政区划",
          children: [
            {
              value: "济源市",
              label: "济源市",
            },
          ],
        },
      ],
      options1: [
        {
          value: "农、林、牧、渔业",
          label: "农、林、牧、渔业",
          children: [
            {
              value: "农业",
              label: "农业",
            },
            {
              value: "畜牧业",
              label: "畜牧业",
            },
            {
              value: "渔业",
              label: "渔业",
            },
            {
              value: "农、林、牧、渔专业及辅助性活动",
              label: "农、林、牧、渔专业及辅助性活动",
            },
          ],
        },
        {
          value: "采矿业",
          label: "采矿业",
          children: [
            {
              value: "煤炭开采和洗选业",
              label: "煤炭开采和洗选业",
            },
            {
              value: "石油和天然气开采业",
              label: "石油和天然气开采业",
            },
            {
              value: "黑色金属矿采选业",
              label: "黑色金属矿采选业",
            },
            {
              value: "有色金属矿采选业",
              label: "有色金属矿采选业",
            },
            {
              value: "非金属矿采选业",
              label: "非金属矿采选业",
            },
            {
              value: "开采专业及辅助性活动",
              label: "开采专业及辅助性活动",
            },
            {
              value: "其他采矿业",
              label: "其他采矿业",
            },
          ],
        },
        {
          value: "制造业",
          label: "制造业",
          children: [
            {
              value: "农副食品加工业",
              label: "农副食品加工业",
            },
            {
              value: "食品制造业",
              label: "食品制造业",
            },
            {
              value: "酒、饮料和精制茶制造业",
              label: "酒、饮料和精制茶制造业",
            },
            {
              value: "烟草制品业",
              label: "烟草制品业",
            },
            {
              value: "纺织业",
              label: "纺织业",
            },
            {
              value: "纺织服装、服饰业",
              label: "纺织服装、服饰业",
            },
            {
              value: "皮革、毛皮、羽毛及其制品和制鞋业",
              label: "皮革、毛皮、羽毛及其制品和制鞋业",
            },
            {
              value: "木材加工和木、竹、藤、棕、草制品业",
              label: "木材加工和木、竹、藤、棕、草制品业",
            },
            {
              value: "家具制造业",
              label: "家具制造业",
            },
            {
              value: "造纸和纸制品业",
              label: "造纸和纸制品业",
            },
            {
              value: "印刷和记录媒介复制业",
              label: "印刷和记录媒介复制业",
            },
            {
              value: "文教、工美、体育和娱乐用品制造业",
              label: "文教、工美、体育和娱乐用品制造业",
            },
            {
              value: "石油、煤炭及其他燃料加工业",
              label: "石油、煤炭及其他燃料加工业",
            },
            {
              value: "化学原料和化学制品制造业",
              label: "化学原料和化学制品制造业",
            },
            {
              value: "医药制造业",
              label: "医药制造业",
            },
            {
              value: "化学纤维制造业",
              label: "化学纤维制造业",
            },
            {
              value: "橡胶和塑料制品业",
              label: "橡胶和塑料制品业",
            },
            {
              value: "非金属矿物制品业",
              label: "非金属矿物制品业",
            },
            {
              value: "黑色金属冶炼和压延加工业",
              label: "黑色金属冶炼和压延加工业",
            },
            {
              value: "有色金属冶炼和压延加工业",
              label: "有色金属冶炼和压延加工业",
            },
            {
              value: "金属制品业",
              label: "金属制品业",
            },
            {
              value: "通用设备制造业",
              label: "通用设备制造业",
            },
            {
              value: "专用设备制造业",
              label: "专用设备制造业",
            },
            {
              value: "汽车制造业",
              label: "汽车制造业",
            },
            {
              value: "铁路、船舶、航空航天和其他运输设备制造业",
              label: "铁路、船舶、航空航天和其他运输设备制造业",
            },
            {
              value: "电气机械和器材制造业",
              label: "电气机械和器材制造业",
            },
            {
              value: "计算机、通信和其他电子设备制造业",
              label: "计算机、通信和其他电子设备制造业",
            },
            {
              value: "仪器仪表制造业",
              label: "仪器仪表制造业",
            },
            {
              value: "其他制造业",
              label: "其他制造业",
            },
            {
              value: "废弃资源综合利用业",
              label: "废弃资源综合利用业",
            },
            {
              value: "金属制品、机械和设备修理业",
              label: "金属制品、机械和设备修理业",
            },
          ],
        },
        {
          value: "电力、热力、燃气及水生产和供应业",
          label: "电力、热力、燃气及水生产和供应业",
          children: [
            {
              value: "电力、热力生产和供应业",
              label: "电力、热力生产和供应业",
            },
            {
              value: "燃气生产和供应业",
              label: "燃气生产和供应业",
            },
            {
              value: "水的生产和供应业",
              label: "水的生产和供应业",
            },
          ],
        },
        {
          value: "建筑业",
          label: "建筑业",
          children: [
            {
              value: "房屋建筑业",
              label: "房屋建筑业",
            },
            {
              value: "建筑安装业",
              label: "建筑安装业",
            },
            {
              value: "建筑装饰、装修和其他建筑业",
              label: "建筑装饰、装修和其他建筑业",
            },
          ],
        },
        {
          value: "批发和零售业",
          label: "批发和零售业",
          children: [
            {
              value: "批发业",
              label: "批发业",
            },
            {
              value: "零售业",
              label: "零售业",
            },
          ],
        },
        {
          value: "交通运输、仓储和邮政业",
          label: "交通运输、仓储和邮政业",
          children: [
            {
              value: "铁路运输业",
              label: "铁路运输业",
            },
            {
              value: "道路运输业",
              label: "道路运输业",
            },
            {
              value: "水上运输业",
              label: "水上运输业",
            },
            {
              value: "航空运输业",
              label: "航空运输业",
            },
            {
              value: "管道运输业",
              label: "管道运输业",
            },
            {
              value: "多式联运和运输代理业",
              label: "多式联运和运输代理业",
            },
            {
              value: "装卸搬运和仓储业",
              label: "装卸搬运和仓储业",
            },
            {
              value: "邮政业",
              label: "邮政业",
            },
          ],
        },
        {
          value: "住宿和餐饮业",
          label: "住宿和餐饮业",
          children: [
            {
              value: "住宿业",
              label: "住宿业",
            },
            {
              value: "餐饮业",
              label: "餐饮业",
            },
          ],
        },
        {
          value: "信息传输、软件和信息技术服务业",
          label: "信息传输、软件和信息技术服务业",
          children: [
            {
              value: "电信、广播电视和卫星传输服务",
              label: "电信、广播电视和卫星传输服务",
            },
            {
              value: "互联网和相关服务",
              label: "互联网和相关服务",
            },
            {
              value: "软件和信息技术服务业",
              label: "软件和信息技术服务业",
            },
          ],
        },
        {
          value: "金融业",
          label: "金融业",
          children: [
            {
              value: "货币金融服务",
              label: "货币金融服务",
            },
            {
              value: "资本市场服务",
              label: "资本市场服务",
            },
            {
              value: "保险业",
              label: "保险业",
            },
            {
              value: "其他金融业",
              label: "其他金融业",
            },
          ],
        },
        {
          value: "房地产业",
          label: "房地产业",
          children: [
            {
              value: "房地产业",
              label: "房地产业",
            },
          ],
        },
        {
          value: "租赁和商务服务业",
          label: "租赁和商务服务业",
          children: [
            {
              value: "租赁业",
              label: "租赁业",
            },
            {
              value: "商务服务业",
              label: "商务服务业",
            },
          ],
        },
        {
          value: "科学研究和技术服务业",
          label: "科学研究和技术服务业",
          children: [
            {
              value: "研究和试验发展",
              label: "研究和试验发展",
            },
            {
              value: "专业技术服务业",
              label: "专业技术服务业",
            },
            {
              value: "科技推广和应用服务业",
              label: "科技推广和应用服务业",
            },
          ],
        },
        {
          value: "水利、环境和公共设施管理业",
          label: "水利、环境和公共设施管理业",
          children: [
            {
              value: "水利管理业",
              label: "水利管理业",
            },
            {
              value: "生态保护和环境治理业",
              label: "生态保护和环境治理业",
            },
            {
              value: "公共设施管理业",
              label: "公共设施管理业",
            },
            {
              value: "土地管理业",
              label: "土地管理业",
            },
          ],
        },
        {
          value: "居民服务、修理和其他服务业",
          label: "居民服务、修理和其他服务业",
          children: [
            {
              value: "居民服务业",
              label: "居民服务业",
            },
            {
              value: "机动车、电子产品和日用产品修理业",
              label: "机动车、电子产品和日用产品修理业",
            },
            {
              value: "其他服务业",
              label: "其他服务业",
            },
          ],
        },
        {
          value: "教育",
          label: "教育",
          children: [
            {
              value: "教育",
              label: "教育",
            },
          ],
        },
        {
          value: "卫生和社会工作",
          label: "卫生和社会工作",
          children: [
            {
              value: "卫生",
              label: "卫生",
            },
            {
              value: "社会工作",
              label: "社会工作",
            },
          ],
        },
        {
          value: "文化、体育和娱乐业",
          label: "文化、体育和娱乐业",
          children: [
            {
              value: "新闻和出版业",
              label: "新闻和出版业",
            },
            {
              value: "广播、电视、电影和录音制作业",
              label: "广播、电视、电影和录音制作业",
            },
            {
              value: "文化艺术业",
              label: "文化艺术业",
            },
            {
              value: "体育",
              label: "体育",
            },
            {
              value: "娱乐业",
              label: "娱乐业",
            },
          ],
        },
        {
          value: "公共管理、社会保障和社会组织",
          label: "公共管理、社会保障和社会组织",
          children: [
            {
              value: "中国共产党机关",
              label: "中国共产党机关",
            },
            {
              value: "国家机构",
              label: "国家机构",
            },
            {
              value: "人民政协、民主党派",
              label: "人民政协、民主党派",
            },
            {
              value: "社会保障",
              label: "社会保障",
            },
            {
              value: "群众团体、社会团体和其他成员组织",
              label: "群众团体、社会团体和其他成员组织",
            },
            {
              value: "基层群众自治组织及其他组织",
              label: "基层群众自治组织及其他组织",
            },
          ],
        },
        {
          value: "国际组织",
          label: "国际组织",
          children: [
            {
              value: "国际组织",
              label: "国际组织",
            },
          ],
        },
      ],
      options2: [
        {
          value: "",
          label: "空",
        },
        {
          value: "电子信息",
          label: "电子信息",
        },
        {
          value: "航空航天",
          label: "航空航天",
        },
        {
          value: "新材料",
          label: "新材料",
        },
        {
          value: "高技术服务",
          label: "高技术服务",
        },
        {
          value: "资源与环境",
          label: "资源与环境",
        },
        {
          value: "新能源及节能",
          label: "新能源及节能",
        },
        {
          value: "高新技术改造传统行业",
          label: "高新技术改造传统行业",
        },
        {
          value: "智能制造",
          label: "智能制造",
        },
        {
          value: "汽车制造",
          label: "汽车制造",
        },
        {
          value: "智能传感器",
          label: "智能传感器",
        },
        {
          value: "食品制造",
          label: "食品制造",
        },
        {
          value: "现代农业",
          label: "现代农业",
        },
        {
          value: "跨境电商",
          label: "跨境电商",
        },
        {
          value: "工业互联网",
          label: "工业互联网",
        },
        {
          value: "5G",
          label: "5G",
        },
        {
          value: "大数据",
          label: "大数据",
        },
        {
          value: "物联网",
          label: "物联网",
        },
        {
          value: "人工智能",
          label: "人工智能",
        },
        {
          value: "区块链",
          label: "区块链",
        },
        {
          value: "文化创意",
          label: "文化创意",
        },
        {
          value: "公共安全",
          label: "公共安全",
        },
        {
          value: "生命健康产业",
          label: "生命健康产业",
        },
        {
          value: "中医药医疗服务",
          label: "中医药医疗服务",
        },
        {
          value: "生物、新医药和高性能医疗器械",
          label: "生物、新医药和高性能医疗器械",
        },
        {
          value: "疫情防控",
          label: "疫情防控",
        },
        {
          value: "其它",
          label: "其它",
        },
      ],
      options3: [
        {
          value: "",
          label: "空",
        },
        {
          value: "企业",
          label: "企业",
        },
        {
          value: "高校、科研院所",
          label: "高校、科研院所",
        },
        {
          value: "事业单位",
          label: "事业单位",
        },
      ],
      options4: [
        {
          value: "高新技术企业",
          label: "高新技术企业",
        },
        {
          value: "科技小巨人企业",
          label: "科技小巨人企业",
        },
        {
          value: "专精特新企业",
          label: "专精特新企业",
        },
        {
          value: "创新龙头企业",
          label: "创新龙头企业",
        },
        {
          value: "瞪羚企业",
          label: "瞪羚企业",
        },
        {
          value: "雏鹰企业",
          label: "雏鹰企业",
        },
        {
          value: "科技型中小企业",
          label: "科技型中小企业",
        },
      ],
      options5: [
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      rules: {
        company_name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        area: {
          required: true,
          message: "请输入注册地区",
          trigger: "blur",
        },
      },
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.userid = localStorage.getItem("RealID");
       //this.userid = "13803853629";
      //  this.userid = "10835";
      //this.getForm();
      this.getCompany();
      this.getTime();
      this.getForm();
    });
  },
  methods: {
    getTime() {
      this.last1 = new Date().getFullYear() - 1;
      this.last2 = new Date().getFullYear() - 2;
      this.last3 = new Date().getFullYear() - 3;
    },
    closeWindow() {
      this.$emit("closeWindow");
    },
    getRowClass() {
      return "background:#f4f7fa";
    },
    postForm() {
      this.jsonData.user_id = this.userid;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: "http://1.192.121.29:9000/api/nttzzc/company/save",
        // url: "http://192.168.1.101:8000/api/nttzzc/company/save",
        data: this.jsonData,
      })
        .then((res) => {
          var status = res.status;
          if (status === 200) {
            this.$message.success("提交成功");
            let routeUrl = this.$router.resolve({
              path: "/result",
              query: {
                policy_id: this.policy_id,
              },
            });
            window.open(routeUrl.href, "_blank");
            this.closeWindow();
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompany() {
      axios({
        method: "get",
        url: "http://124.70.78.125:8082/WebService/Organization.ashx",
        params: {
          UnitName: this.userid,
          action: "Get_Organization",
        },
      })
        .then((response) => {
          var json = response.data;
          if (json.Code == "200") {
            var s1 = [];
            s1 = JSON.parse(json.Data);
            this.companyName = s1[0].UnitName;
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getForm() {
      axios({
        methods: "get",
        url: "http://1.192.121.29:9000/api/nttzzc/company/schemas",
        // url: "http://192.168.1.101:8000/api/nttzzc/company/schemas",
        params: {
          policy_id: this.policy_id,
          user_id: this.userid,
        },
      })
        .then((res) => {
          var json = res.data;
          this.jsonData = json.data;
          this.jsonData.user_id = this.userid;
          if (this.jsonData.hasOwnProperty("company_name")) {
            this.jsonData.company_name = this.jsonData.company_name;
            if (this.jsonData.company_name == "") {
              this.jsonData.company_name = this.companyName;
            }
            this.ruleForm.company_name = true;
          } else {
            this.jsonData.company_name = this.companyName;
            this.ruleForm.company_name = true;
          }
          this.ruleForm.company_name = true;
          if (this.jsonData.hasOwnProperty("company_code")) {
            this.jsonData.company_code = this.jsonData.company_code;
            this.ruleForm.company_code = true;
          }
          if (this.jsonData.hasOwnProperty("registration_time")) {
            this.jsonData.registration_time = this.jsonData.registration_time;
            this.ruleForm.registration_time = true;
          }
          if (this.jsonData.hasOwnProperty("area")) {
            this.jsonData.area = this.jsonData.area;
            this.jsonData.area = this.jsonData.area.substr(
              3,
              this.jsonData.area.length
            );
            console.log(this.jsonData.area);
            this.ruleForm.area = true;
          }
          if (this.jsonData.hasOwnProperty("economy_industry")) {
            this.jsonData.economy_industry = this.jsonData.economy_industry;
            this.ruleForm.economy_industry = true;
          }
          if (this.jsonData.hasOwnProperty("policy_industry")) {
            this.jsonData.policy_industry = this.jsonData.policy_industry;
            this.ruleForm.policy_industry = true;
          }
          if (this.jsonData.hasOwnProperty("company_type")) {
            this.jsonData.company_type = this.jsonData.company_type;
            this.ruleForm.company_type = true;
          }
          if (this.jsonData.hasOwnProperty("qualification")) {
            this.jsonData.qualification = this.jsonData.qualification;
            this.ruleForm.qualification = true;
          }
          if (this.jsonData.hasOwnProperty("listed_company")) {
            this.jsonData.listed_company = this.jsonData.listed_company;
            this.ruleForm.listed_company = true;
          }
          if (this.jsonData.hasOwnProperty("is_cooperation")) {
            this.jsonData.is_cooperation = this.jsonData.is_cooperation;
            this.ruleForm.is_cooperation = true;
          }
          if (this.jsonData.hasOwnProperty("is_violation")) {
            this.jsonData.is_violation = this.jsonData.is_violation;
            this.ruleForm.is_violation = true;
          }
          if (this.jsonData.hasOwnProperty("employees_num")) {
            this.jsonData.employees_num = this.jsonData.employees_num;
            this.ruleForm.employees_num = true;
          }
          if (this.jsonData.hasOwnProperty("researcher_num")) {
            this.jsonData.researcher_num = this.jsonData.researcher_num;
            this.ruleForm.researcher_num = true;
          }
          if (this.jsonData.hasOwnProperty("college_num")) {
            this.jsonData.college_num = this.jsonData.college_num;
            this.ruleForm.college_num = true;
          }
          if (this.jsonData.hasOwnProperty("undergraduate_num")) {
            this.jsonData.undergraduate_num = this.jsonData.undergraduate_num;
            this.ruleForm.undergraduate_num = true;
          }
          if (this.jsonData.hasOwnProperty("master_num")) {
            this.jsonData.master_num = this.jsonData.master_num;
            this.ruleForm.master_num = true;
          }
          if (this.jsonData.hasOwnProperty("doctor_num")) {
            this.jsonData.doctor_num = this.jsonData.doctor_num;
            this.ruleForm.doctor_num = true;
          }
          if (this.jsonData.hasOwnProperty("academician_num")) {
            this.jsonData.academician_num = this.jsonData.academician_num;
            this.ruleForm.academician_num = true;
          }
          if (this.jsonData.hasOwnProperty("intermediate_num")) {
            this.jsonData.intermediate_num = this.jsonData.intermediate_num;
            this.ruleForm.intermediate_num = true;
          }
          if (this.jsonData.hasOwnProperty("senior_num")) {
            this.jsonData.senior_num = this.jsonData.senior_num;
            this.ruleForm.senior_num = true;
          }
          if (this.jsonData.hasOwnProperty("assets1")) {
            this.jsonData.assets1 = this.jsonData.assets1;
            this.ruleForm.assets1 = true;
          }
          if (this.jsonData.hasOwnProperty("income1")) {
            this.jsonData.income1 = this.jsonData.income1;
            this.ruleForm.income1 = true;
          }
          if (this.jsonData.hasOwnProperty("profit1")) {
            this.jsonData.profit1 = this.jsonData.profit1;
            this.ruleForm.profit1 = true;
          }
          if (this.jsonData.hasOwnProperty("research1")) {
            this.jsonData.research1 = this.jsonData.research1;
            this.ruleForm.research1 = true;
          }
          if (this.jsonData.hasOwnProperty("assets2")) {
            this.jsonData.assets2 = this.jsonData.assets2;
            this.ruleForm.assets2 = true;
          }
          if (this.jsonData.hasOwnProperty("income2")) {
            this.jsonData.income2 = this.jsonData.income2;
            this.ruleForm.income2 = true;
          }
          if (this.jsonData.hasOwnProperty("profit2")) {
            this.jsonData.profit2 = this.jsonData.profit2;
            this.ruleForm.profit2 = true;
          }
          if (this.jsonData.hasOwnProperty("research2")) {
            this.jsonData.research2 = this.jsonData.research2;
            this.ruleForm.research2 = true;
          }
          if (this.jsonData.hasOwnProperty("assets3")) {
            this.jsonData.assets3 = this.jsonData.assets3;
            this.ruleForm.assets3 = true;
          }
          if (this.jsonData.hasOwnProperty("income3")) {
            this.jsonData.income3 = this.jsonData.income3;
            this.ruleForm.income3 = true;
          }
          if (this.jsonData.hasOwnProperty("profit3")) {
            this.jsonData.profit3 = this.jsonData.profit3;
            this.ruleForm.profit3 = true;
          }
          if (this.jsonData.hasOwnProperty("research3")) {
            this.jsonData.research3 = this.jsonData.research3;
            this.ruleForm.research3 = true;
          }
          if (this.jsonData.hasOwnProperty("invention_patent")) {
            this.jsonData.invention_patent = this.jsonData.invention_patent;
            this.ruleForm.invention_patent = true;
          }
          if (this.jsonData.hasOwnProperty("utility_model_patent")) {
            this.jsonData.utility_model_patent =
              this.jsonData.utility_model_patent;
            this.ruleForm.utility_model_patent = true;
          }
          if (this.jsonData.hasOwnProperty("industrial_design_patent")) {
            this.jsonData.industrial_design_patent =
              this.jsonData.industrial_design_patent;
            this.ruleForm.industrial_design_patent = true;
          }
          if (this.jsonData.hasOwnProperty("software_copyright")) {
            this.jsonData.software_copyright = this.jsonData.software_copyright;
            this.ruleForm.software_copyright = true;
          }
          if (this.jsonData.hasOwnProperty("other_copyright")) {
            this.jsonData.other_copyright = this.jsonData.other_copyright;
            this.ruleForm.other_copyright = true;
          }
          if (this.jsonData.hasOwnProperty("高新技术产品收入占比")) {
            delete this.jsonData.高新技术产品收入占比;
          }
          if (this.jsonData.hasOwnProperty("高新技术领域")) {
            delete this.jsonData.高新技术领域;
          }
          console.log(this.jsonData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none !important;
}

.msg {
  position: absolute;
  z-index: 200;
  top: 36%;
  left: 12%;
  border-radius: 10px;
  background-color: #fff;
  width: 77%;
  text-align: left;
  min-height: 100%;
  box-shadow: 0px 0px 20px 0px rgba(39, 41, 43, 0.2);

  .close {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .content {
    margin-top: 10px;
    padding: 50px;
    min-height: 1300px;

    .title {
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .basic {
      .title1 {
        display: flex;
        font-size: 23px;
        font-weight: 600;
        padding-bottom: 20px;
        margin-bottom: 30px;
        border-bottom: 2px solid #eaeaea;
      }
    }
  }

  .el-form-item {
    margin-right: 30px;
    margin-left: 20px;
  }

  ::v-deep .el-form-item__label {
    font-size: 16px !important;
    margin-right: 10px;
  }

  .explain {
    padding-left: 18px;
    transform: translateY(5px);
    margin-bottom: 8px;
    font-size: 15px;
    color: #ff8616;
    width: 50%;
    margin-right: 0!important;
  }

  .explain_item {
    transform: translateX(-130px);
    font-size: 15px;
    color: #ff8616;
  }

  .line {
    display: inline-block;

    ::v-deep .el-form-item__label {
      line-height: 20px !important;
    }
  }

  table {
    width: 100%;
    border: 1px solid #e2e6e9;
    border-collapse: collapse;
    color: #474f57;
  }

  td {
    border: 1px solid #dee2e6;
    height: 70px;
    vertical-align: middle;
    text-align: center;
  }

  .tab-title {
    font-weight: 600;
  }
}
</style>
